<iframe id="frame" name="frame" class="custom-frame" width="100%" height="100%" [src]="getWopiUrl()"></iframe>

<!-- The form is hidden on purpose and demonstrates automatically posting the form data to the endpoint loaded within the above iframe AfterViewInit. -->
<form #form target="frame" method="POST" hidden="hidden" [action]="getWopiUrl()" (ngSubmit)="submitForm($event)">
    <input type="hidden" id="access_token" name="access_token" [value]="accessToken"/>
    <input type="hidden" id="access_token_ttl" name="access_token_ttl" [value]="accessTokenTTL"/>
    <input type="hidden" name="user_id" [value]="userId"/>
    <input type="hidden" name="owner_id" [value]="userId"/>
</form>
